// src/services/SubscriptionVerificationService.js
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../config/firebase";
import SubscriptionService from "./SubscriptionService";

/**
 * SubscriptionOverviewPage verification via Stripe (cloud function). Optional native wrapper
 * identifies the logged-in user for push token updates only.
 */
class SubscriptionVerificationService {
  static getInstance() {
    if (!SubscriptionVerificationService.instance) {
      SubscriptionVerificationService.instance =
        new SubscriptionVerificationService();
    }
    return SubscriptionVerificationService.instance;
  }

  /**
   * Sync native push tokens for the logged-in user when running in the app wrapper.
   * @param {string} [uid] — If omitted, uses Firebase auth uid. If set to another uid, no-ops
   * (used by legacy call sites that previously switched native purchase context).
   */
  async identifyUser(uid) {
    try {
      const { auth } = await import("../config/firebase");
      const currentUser = auth?.currentUser;

      if (!currentUser) {
        return { success: false, error: "No authenticated user" };
      }

      const resolvedUid = uid || currentUser.uid;
      if (resolvedUid !== currentUser.uid) {
        return { success: true };
      }

      try {
        const response = await SubscriptionService.sendMessage(
          "UPDATE_PUSH_TOKEN_USER",
          {
            userId: resolvedUid,
            userEmail: currentUser.email || null,
          }
        );
        if (response.success) {
          return { success: true };
        }
        return {
          success: false,
          error: response.error || "Failed to update push tokens",
        };
      } catch (e) {
        if (
          e.message === "Not running in app wrapper" ||
          e.message === "Request timeout"
        ) {
          return { success: true };
        }
        return { success: false, error: e.message };
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  async verifySubscription(options = {}) {

    try {
      const joinCode =
        typeof options.joinCode === "string" ? options.joinCode.trim() : "";
      const { auth } = await import("../config/firebase");
      const currentUser = auth?.currentUser;


      console.log("67 alive 0")

      if (!currentUser) {
        return { isValid: false, reason: "no_authenticated_user" };
      }

      const functions = getFunctions(app, "europe-west1");


      console.log("67 alive 1")

      if (joinCode) {
        const getLeadStatus = httpsCallable(
          functions,
          "getLeadsStripeSubscriptionStatus"
        );
        const result = await getLeadStatus({ joinCode });
        const has = result.data?.hasStripeSubscription === true;
        if (!has) {
          return { isValid: false, reason: "subscription_inactive" };
        }
        return { isValid: true };
      }



      console.log("67 alive 2")

      let uid = options.uid;
      if (!uid) {
        uid = currentUser.uid;
      }

      console.log("67 alive 3")


      const getStatus = httpsCallable(functions, "getStripeSubscriptionStatus");
      const payload = uid !== currentUser.uid ? { forUid: uid } : {};
      const result = await getStatus(payload);
      const has = result.data?.hasStripeSubscription === true;


      console.log("67 alive 4")

      if (!has) {
        return { isValid: false, reason: "subscription_inactive" };
      }

      console.log("67 alive 5")

      return { isValid: false };
    } catch (error) {

      console.log("67 alive 6")
      console.warn("verifySubscription:", error?.code, error?.message, error);
      return { isValid: false, reason: "verification_error" };
    }
  }
}

export default SubscriptionVerificationService.getInstance();
